export const qkBaseFactor = ['factors']

//getWhiteLabel
export const qkGetWhiteLabel = () => [...qkBaseFactor, 'whiteLabels']

//getFeatureFlags
export const qkGetFeatureFlags = () => [...qkBaseFactor, 'feature-flags']

export const qkGetFactorMeTimezone = () => [...qkBaseFactor, 'me', 'timezone']

//getFactorSettings
export const qkGetFactorSettings = (factorId?: string | null) => [...qkBaseFactor, 'settings', factorId]
